(ns dashboard.views
  (:require [re-frame.core :as rf]
            [react]
            [dashboard.routes :as routes]
            [dashboard.subs :as subs]
            [dashboard.ui :as ui]
            [dashboard.components.navbar :refer [navbar]]
            [dashboard.components.browser-extension-bar :refer [browser-extension-bar]]
            [dashboard.components.flash-screen :refer [flash-screen]]
            [dashboard.components.errors :refer [error-boundary error-container]]
            [dashboard.components.notifications :refer [notifications-container]]
            [dashboard.notifications :as notifications]
            [dashboard.browser-extension :as browser-extension]
            [dashboard.components.search.events :as search-events]
            [dashboard.components.search.view :as search-view]
            [dashboard.components.search.subs :as search-subs]
            [dashboard.components.keybindings :refer [keybindings]]))

(defn main-panel []
  ;; TODO: footer
  (let [initialized                   @(rf/subscribe [::subs/app.initialized])
        {:keys [hero layout content]} @(rf/subscribe [::subs/view.data])
        error                         @(rf/subscribe [::subs/error])
        notifications                 @(rf/subscribe [::subs/app.notifications])
        modals                        @(rf/subscribe [::subs/ui.modals])

        route @(rf/subscribe [::subs/route])
        mode (get-in route [:parameters :query :mode])

        search-visible? @(rf/subscribe [::search-subs/search-visible])

        extension-path? (browser-extension/is-browser-extension-path?)
        is-extension-expanded @(browser-extension/is-extension-expanded)

        is-embedded? (or (= mode "embed") extension-path?)
        structured-analysis-creation-enabled? @(rf/subscribe [::subs/feature-enabled :structured-analysis-creation])]

    (react/useEffect
     (fn []
       (let [classes (.. js/document -documentElement -classList)
             scroll-top (.. js/document -documentElement -scrollTop)]
         (when (or (seq modals) search-visible?)
           (.setProperty (.. js/document -documentElement -style) "--st" (str "-" scroll-top "px"))
           (.add classes "modal-open"))
         (fn []
           (when (or (seq modals) search-visible?)
             (.remove classes "modal-open")
             (set! (.. js/document -documentElement -scrollTop) scroll-top)))))
     (array modals search-visible?))

    (if initialized
      (if (:content-only layout)
        [:f> content]
        [:f> keybindings {:actions {"/" #(rf/dispatch [::search-events/set-search-visible true])}}
         [:<>
          [navbar routes/app-routes]
          (when is-embedded?
            [browser-extension-bar])

          (when (or (not is-embedded?)
                    is-extension-expanded)
            [:div.application-main-view
             {:style (merge {:min-height (if is-extension-expanded
                                           "calc(100vh - 50px)"
                                           "62px")
                             :display :flex
                             :flex-direction :column}
                            (when is-embedded?
                              {:align-items "stretch"
                               :overflow "auto"}))}
             (when hero ;; If route has hero component render it
               [:div.hero.has-background-tertiary.is-flex-grow-1
                {:class (when structured-analysis-creation-enabled? :administration-mode)}
                [:div.hero-body.is-flex>div.container.is-flex
                 [:div.section
                  {:style {:margin "auto"}}
                  [hero]]]])

             (when (and content (not hero))
            ;; Wrap views in React ErrorBoundary
            ;; https://reactjs.org/docs/error-boundaries.html
               [error-boundary
                (if (:is-fullwidth? layout)
                  [:f> content]
                  [:div.is-flex-grow-1 [:f> content]])])

             (when error ;; this is for error notification component, different from error boundary
               [error-container {:error           error
                                 :on-delete-error #(rf/dispatch [::ui/clear-error])}])

             (doall
              (map-indexed
               (fn [i {:keys [component ctx on-close content-props keybinding-overrides]}]
                 (let [close (fn []
                               (when on-close
                                 (on-close))
                               (rf/dispatch [::ui/pop-modal]))]
                   [:div.modal.is-active {:key (str "modal-" i)
                                          :style {:position "fixed" :top 0 :z-index 1000}}
                    [:div.modal-background {:on-click close
                                            :style {:overflow "scroll"}}]
                    [:f> keybindings {:actions (merge {"Escape" close}
                                                      keybinding-overrides)}
                     [:div
                      (assoc content-props
                             :style (merge (:style content-props)
                                           {:overflow "hidden"
                                            :transform (str "translate(" (* (mod i 3) 12) "px, " (* (mod i 3) 12) "px)")})
                             :class (apply conj (-> content-props :class vector flatten)
                                           [:modal-content :is-flex-direction-column]))
                      [:f> component {:ctx      ctx
                                      :on-close close}]
                      ;; Someday maybe
                      #_[:button.button.modal-close-button {:on-click close} "Close"]]]]))

               (reverse modals)))

             (when (and search-visible?
                        (not is-embedded?))
               [search-view/quick-search false])

             (when notifications
               [notifications-container
                {:notifications          notifications
                 :on-delete-notification (fn [notification]
                                           (rf/dispatch [::notifications/remove notification]))}])])]])
      ;; Render flash screen if UI not initialized
      [flash-screen])))
